// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "circle[data-v-dd92eb4e] {\n  stroke: currentColor;\n}\npath[data-v-dd92eb4e] {\n  fill: currentColor;\n}", ""]);
// Exports
module.exports = exports;
